import { useMutation } from '@tanstack/react-query';
import {
    agentRole,
  UserApiService,
} from 'features/users/api/user-api.service';


const { saveagentEventAccess } = UserApiService();

export const useCreteEventAcessAgentRole = () => {

  return useMutation(
    (payload: agentRole) => {
      return saveagentEventAccess(payload);
    },
  );
};





